import React from 'react';

class WizardItemTextInputSingleLine extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			value: ""
		};

		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		let trimmedString = e.target.value.substring(0, this.props.data.MaximumNumberOfCharacters);
		this.setState({ value: trimmedString });
		this.props.submitAnswer(trimmedString);
	}

	render() {
		return (
			<div className="wizard-item wizard-item__fake-result wizard-item__single-line">
				<input placeholder={this.props.data.PlaceholderText} type="text" value={this.state.value} onChange={this.onChange} data-trackingid={this.props.data.QuestionTrackingId} />
			</div>
		)
	}
}

export default WizardItemTextInputSingleLine;